export class SurCase30DayStatusModel {
  SurCase30DayStatusId: number;
  SurCaseId: number;
  IsPatientAlive: string;
  IsPatientDischarged: string;
  IsPatientDoingWell: string;
  Updatedby: string;
}
